export default __webpack_public_path__ + "static/media/laundry2-before-1024w.99d43a00.png";